var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"ml-0 mt-3",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"mapa-leaflet",attrs:{"id":_vm.idMapa}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }